<template>
  <div>
    前端小智 https://www.ixigua.com/home/2399726689/
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CSsDefault"
});
</script>
